import { Component, OnInit } from '@angular/core';

export interface Education {
  degree: string;
  year: string;
  college: string;
}

export interface Moocs {
  course: string;
  year: string;
  mooc: string;
}

export interface Certifications {
  certification: string;
  year: string;
  authority: string;
}

const ELEMENT_EDUCATION: Education[] = [
  { year: '2005 (School Captain)', degree: 'Inter', college: 'Atomic Energy Central School, Indore' },
  { year: '2009 (Sports Secretary)', degree: 'B.Tech in Computer Science', college: 'Indian Institute of Information Technology, Design and Manufacturing, Jabalpur' },
  { year: '2011 (Team Lead)', degree: 'MBA in Software Enterprise Management', college: 'Center for Development of Advance Computing, Noida' },
];

const ELEMENT_MOOC: Moocs[] = [
  { year: '2016', course: 'MongoDB Database Administration', mooc: 'MongoDB University' },
  { year: '2018 (Jan)', course: 'Google Daydream - VR and 360 Video Production', mooc: 'Coursera' },
  { year: '2018 (May)', course: 'Architecting with Google Cloud Platform', mooc: 'Coursera - 6 Course Specialization' },
  { year: '2018 (June)', course: 'Data Engineering on Google Cloud Platform', mooc: 'Coursera - 5 Course Specialization ' },
];

const ELEMENT_CERTIFICATION: Certifications[] = [
  { year: '2014', certification: 'QAD Enterprise Edition Technical Implementation', authority: 'QAD' },
  { year: '2018 (Apr)', certification: 'Dell Boomi Professional Developer', authority: 'Dell Boomi' },
  { year: '2018 (July)', certification: 'Dell Boomi Professional API Design and Management', authority: 'Dell Boomi' },
  { year: '2018 (Planned - Dec)', certification: 'Google Cloud Platform Architect', authority: 'Google Cloud' },
];




@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.css']
})
export class EducationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  displayedCertification: string[] = ['year', 'certification', 'authority'];
  dataCertification = ELEMENT_CERTIFICATION;

  displayedEducation: string[] = ['year', 'degree', 'college'];
  dataEducation = ELEMENT_EDUCATION;

  displayedMooc: string[] = ['year', 'course', 'mooc'];
  dataMooc = ELEMENT_MOOC;

}
